import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { Box, CircularProgress, Typography } from '@mui/material';

interface ProtectedRouteProps {
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        const verifyToken = async () => {
            const token = localStorage.getItem('adminToken');
            
            // Pas de token = pas authentifié
            if (!token) {
                setIsAuthenticated(false);
                return;
            }

            // Vérifier le token auprès du backend
            try {
                await axios.get('/api/auth/me', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                // Token valide
                setIsAuthenticated(true);
            } catch (error) {
                // Token invalide ou expiré
                console.error('Token invalide ou expiré');
                localStorage.removeItem('adminToken');
                setIsAuthenticated(false);
            }
        };

        verifyToken();
    }, []);

    // Afficher un loader pendant la vérification
    if (isAuthenticated === null) {
        return (
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '60vh',
                gap: 2
            }}>
                <CircularProgress size={60} />
                <Typography variant="h6" color="text.secondary">
                    Vérification de l'authentification...
                </Typography>
            </Box>
        );
    }

    // Rediriger vers l'accueil si pas authentifié
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Afficher le composant protégé si authentifié
    return children;
};

export default ProtectedRoute;

